module.exports = __webpack_public_path__ + "static/img/loadingIcon.e014c7a0.png";